import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import RemoteSVG from '$components/RemoteSVG/RemoteSVG';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import Home from '../../Home/Home';
import ForgotPasswordForm from '../../EmployerForgotPasswordForm/EmployerForgotPasswordForm';

const EmployerForgotPasswordScreen = () => {
  const [t] = useTranslation('global');
  const { logoUrl } = useAppSelector((state) => state.brand);
  return (
    <Home>
      <div className="w-screen h-screen flex justify-center bg-employer-background font-mulish text-spk-highContrast relative">
        <div className="flex gap-28 relative min-w-[50%] top-1/4">
          <div className="absolute left-0 -top-10 flex flex-row gap-3 justify-center">
            {logoUrl && (
              <RemoteSVG svgProps={{ className: 'w-24' }} url={logoUrl} />
            )}
            <div className="flex items-center justify-center w-fit bg-spk-highContrast rounded-md px-1.5">
              <p className="text-sm font-bold text-spk-softBlue110">
                {t('employeeLoginScreen.tag')}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4 min-w-[40%]">
            <h1 className="text-5xl font-black m-0">{t('forgotPass.title')}</h1>
            <p className="text-spk-mediumContrast">
              {t('forgotPass.instructions')}
            </p>
          </div>
          <div className="w-fill-available">
            <ForgotPasswordForm />
          </div>
        </div>
        <div className="absolute bottom-12">
          <p className="text-spk-mediumContrast">
            {t('login.areYouCandidate')}&nbsp;
            <Link to="/login" className="text-employer-primary font-bold">
              {t('login.loginHere')}
            </Link>
          </p>
        </div>
      </div>
    </Home>
  );
};

export default EmployerForgotPasswordScreen;
